import { Component, Input, OnInit } from '@angular/core';
import { CustomerEmergencyContact } from '../../../../../../../models/customer';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CustomerService } from '../../../../../../../services/customer/customer.service';
import { CallbackResult, CallbackResultStatus } from '../../../../../../../utils';

@Component({
  selector: 'app-customer-emergency-contact-modal',
  templateUrl: './customer-emergency-contact-modal.component.html',
  styleUrls: ['./customer-emergency-contact-modal.component.css']
})
export class CustomerEmergencyContactModalComponent implements OnInit {

  @Input() customerId: number;
  @Input() emergencyContact: CustomerEmergencyContact = null;
  @Input() savedCallback: (result: CallbackResult) => undefined;

  public isNewEmergencyContact = false;

  public loadingSubmit = false;
  public errors: any = {};
  public errorMessage = '';
  public serverError: number = null;

  constructor(
    public activeModal: NgbActiveModal,
    public customerService: CustomerService
  ) {}

  public ngOnInit() {
    if (this.emergencyContact === null) {
      this.isNewEmergencyContact = true;
      this.emergencyContact = {
        id: null,
        url: '',
        first_name: '',
        last_name: '',
        telephone: '',
        email: '',
        relation: '',
        is_removed: false,
        created_at: '',
        updated_at: ''
      };
    }
  }

  public handleSave() {
    this.loadingSubmit = true;

    this.errorMessage = '';

    let savePromise: Promise<CustomerEmergencyContact>;

    if (this.isNewEmergencyContact) {
      savePromise = this.customerService
        .addCustomerEmergencyContact(this.customerId, this.emergencyContact);
    } else {
      savePromise = this.customerService
        .updateCustomerEmergencyContact(this.emergencyContact);
    }

    savePromise
      .then(emergencyContact => {
        const successText = (
          'Emergency contact \'' + emergencyContact.first_name + ' ' + emergencyContact.last_name + '\' '
          + (this.isNewEmergencyContact ? 'created' : 'updated') + ' successfully.'
        );
        this.savedCallback({
          text: successText,
          status: CallbackResultStatus.success
        });
        this.activeModal.close();
      })
      .catch(reason => {
        if (reason.status === 400) {
          this.errors = reason.error;
          this.errorMessage = 'Please correct the errors above and try again.';
        } else if (reason.status === 403) {
          this.errorMessage = (
            'You do not have permission to ' + (this.isNewEmergencyContact ? 'create' : 'edit')
            + ' emergency contacts.'
          );
        } else {
          this.serverError = reason.status;
        }
      })
      .finally(() => { this.loadingSubmit = false; });
  }

  public handleRemove() {
    if (!confirm('Are you sure you wish to remove this emergency contact? This action cannot be undone.')) {
      return;
    }

    this.loadingSubmit = true;

    this.errorMessage = '';

    this.customerService
      .removeCustomerEmergencyContact(this.emergencyContact)
      .then(emergencyContact => {
        const successText = (
          'Emergency contact \'' + emergencyContact.first_name + ' ' + emergencyContact.last_name
          + '\' removed successfully.'
        );
        this.savedCallback({
          text: successText,
          status: CallbackResultStatus.success
        });
        this.activeModal.close();
      })
      .catch(reason => {
        if (reason.status === 403) {
          this.errorMessage = 'You do not have permission to remove emergency contacts.';
        } else {
          this.serverError = reason.status;
        }
      })
      .finally(() => { this.loadingSubmit = false; });
  }

}
